/**
 * Pull a user-facing message off an Axios-shaped error.
 *
 * 4xx responses prefer the server's `data.error`, then `data.message` (the
 * shape most `@api_v1.errorhandler`s actually return), then `err.message`,
 * then "Invalid request" as a last resort. Everything else (5xx, network
 * errors, non-Error throws) gets the caller-supplied fallback.
 */
const formatError = (
  err,
  fallback = "An unexpected error occurred. Please try again."
) => {
  const status = err?.response?.status;
  if (typeof status === "number" && status >= 400 && status < 500) {
    return (
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err?.message ||
      "Invalid request"
    );
  }
  return fallback;
};

export default formatError;
export { formatError };
